import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { SeoTags } from '#src/components/SeoTags/index.ts';
import { HomePage } from '#src/pages/HomePage/index.ts';

export const Route = createFileRoute('/{-$locale}/')({
  component: RouteComponent
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <>
      <SeoTags
        title={intl.formatMessage({
          id: 'head.home-page',
          defaultMessage: 'Slash How: Learning starts here'
        })}
        useCurrentCanonicalPath
      />

      <HomePage />
    </>
  );
}
